// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"mAZF70It--FooterLinks_footer-wrapper__pLVnZ","footerWrapper":"mAZF70It--FooterLinks_footer-wrapper__pLVnZ","links":"mAZF70It--FooterLinks_links__Stvew"};